// extracted by mini-css-extract-plugin
export default {"auth__layout":"authentication_auth__layout__KrvIG"};